/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "price/models.proto" (package "rd.price", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { PricingRegion } from "../company/models_pb";
import { FractionalMoney } from "../proto/money/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { Money } from "../proto/money/models_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * A Rule represents a pricing configuration that can be applied to products. A
 * rule can configure tier prices, match prices, custom prices, and promotions.
 *
 * 1. Price Types:
 *    - Tier Prices: Standard pricing levels (e.g., Retail, Contractor, etc.)
 *    - Match Prices: Price matching of product A to product B
 *    - Custom Prices: Special pricing for specific customers. Note that
 *      promotions are custom prices without a customer id specified.
 *
 * 2. Pricing Strategies:
 *    - Fixed Price: A specific monetary amount
 *    - Margin Price: Calculated using a margin percentage
 *    - Discount Price: Percentage off the reference tier price
 *
 * 3. Tier Types:
 *    - Manual Tiers: (e.g., Tier 1) Each product has its own price rule
 *    - Rule-based Tiers: (Tiers 2+) Prices are calculated using rules that
 *      apply across:
 *      * Vendors
 *      * Departments
 *      * Classes
 *      * Finelines
 *
 * The reference_tier_id is used for discount pricing calculations, where the
 * discount percentage is applied to the price from the referenced tier.
 *
 * The expires_at field is optional and is used to determine if the price rule
 * is active for custom prices and promotions. If the rule is not nil and
 * expired, it is inactive. The system will delete rules that are no longer in
 * use for match prices and tier prices.
 *
 * @generated from protobuf message rd.price.Rule
 */
export interface Rule {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 3
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID matched_product_id = 5
     */
    matchedProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 6
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 7
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID class_id = 8
     */
    classId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fineline_id = 9
     */
    finelineId?: UUID;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 10
     */
    pricingTierIdString: string;
    /**
     * @generated from protobuf field: string reference_tier_id_string = 11
     */
    referenceTierIdString: string; // for discount price strategy
    /**
     * @generated from protobuf field: rd.price.Rule.PriceStrategy price_strategy = 13
     */
    priceStrategy: Rule_PriceStrategy;
    /**
     * Value
     *
     * @generated from protobuf field: rd.proto.money.Money fixed_price = 14
     */
    fixedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_percent = 15
     */
    marginPercent?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 16
     */
    discountPercent?: Decimal;
    /**
     * For custom prices
     *
     * @generated from protobuf field: google.protobuf.Timestamp starts_at = 28
     */
    startsAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 17
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.price.Rule.Type type = 18
     */
    type: Rule_Type;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 20
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 21
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool is_price_rounded_up = 22
     */
    isPriceRoundedUp: boolean; // deprecated: use price_rounding_type instead
    /**
     * @generated from protobuf field: string name = 23
     */
    name: string;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceTierType price_tier_type = 24
     */
    priceTierType: Rule_PriceTierType;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID job_id = 25
     */
    jobId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User created_by = 26
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 27
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 29
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 30
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceRoundingType price_rounding_type = 31
     */
    priceRoundingType: Rule_PriceRoundingType;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_tag_id = 32
     */
    productTagId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_tag_id = 33
     */
    customerTagId?: UUID;
    /**
     * For UoM-aware pricing rules.
     * Nil means the product's base unit.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 34
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: int32 quantity_uom = 35
     */
    quantityUom: number; // Quantity threshold in the selected unit of measure.
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID pricing_region_id = 36
     */
    pricingRegionId?: UUID;
    /**
     * For custom prices and promotions; true skips quantity breaks.
     *
     * @generated from protobuf field: bool is_quantity_break_disabled = 37
     */
    isQuantityBreakDisabled: boolean;
}
/**
 * @generated from protobuf enum rd.price.Rule.PriceStrategy
 */
export enum Rule_PriceStrategy {
    /**
     * @generated from protobuf enum value: PRICE_STRATEGY_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PRICE_STRATEGY_FIXED = 1;
     */
    FIXED = 1,
    /**
     * @generated from protobuf enum value: PRICE_STRATEGY_MARGIN = 2;
     */
    MARGIN = 2,
    /**
     * @generated from protobuf enum value: PRICE_STRATEGY_DISCOUNT = 3;
     */
    DISCOUNT = 3
}
/**
 * Type is used to distinguish between the supported pricing rule kinds.
 *
 * @generated from protobuf enum rd.price.Rule.Type
 */
export enum Rule_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_PRICE_TIER = 1;
     */
    PRICE_TIER = 1,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOM_PRICE = 2;
     */
    CUSTOM_PRICE = 2,
    /**
     * @generated from protobuf enum value: TYPE_MATCH_PRICE = 3;
     */
    MATCH_PRICE = 3,
    /**
     * @generated from protobuf enum value: TYPE_ALTERNATE_PRICE = 4;
     */
    ALTERNATE_PRICE = 4
}
/**
 * PriceTierType is used to distinguish between manual price tier rules and
 * rule-based price tier rules
 *
 * @generated from protobuf enum rd.price.Rule.PriceTierType
 */
export enum Rule_PriceTierType {
    /**
     * @generated from protobuf enum value: PRICE_TIER_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PRICE_TIER_TYPE_MANUAL = 1;
     */
    MANUAL = 1,
    /**
     * @generated from protobuf enum value: PRICE_TIER_TYPE_RULE_BASED = 2;
     */
    RULE_BASED = 2
}
/**
 * PriceRoundingType specifies how prices should be rounded when using margin or discount
 * strategies
 *
 * @generated from protobuf enum rd.price.Rule.PriceRoundingType
 */
export enum Rule_PriceRoundingType {
    /**
     * @generated from protobuf enum value: PRICE_ROUNDING_TYPE_NONE = 0;
     */
    PRICE_ROUNDING_TYPE_NONE = 0,
    /**
     * Round to next $X.99
     *
     * @generated from protobuf enum value: PRICE_ROUNDING_TYPE_99 = 1;
     */
    PRICE_ROUNDING_TYPE_99 = 1,
    /**
     * Round to next $X.09, $X.19, $X.29, etc.
     *
     * @generated from protobuf enum value: PRICE_ROUNDING_TYPE_09 = 2;
     */
    PRICE_ROUNDING_TYPE_09 = 2,
    /**
     * Round to next $X.05, $X.15, $X.25, etc.
     *
     * @generated from protobuf enum value: PRICE_ROUNDING_TYPE_05 = 3;
     */
    PRICE_ROUNDING_TYPE_05 = 3
}
/**
 * Tier represents product price information for a specific pricing tier. It
 * contains the calculated price, pricing strategy, and configuration details
 * used by the frontend to display and manage tier-based pricing.
 *
 * The is_reference flag indicates if this tier serves as a base price for
 * calculating other tiers' discount prices.
 *
 * @generated from protobuf message rd.price.Tier
 */
export interface Tier {
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 1
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_percent = 2
     */
    marginPercent?: Decimal;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceStrategy price_strategy = 3
     */
    priceStrategy: Rule_PriceStrategy;
    /**
     * @generated from protobuf field: string tier_id_string = 4
     */
    tierIdString: string;
    /**
     * @generated from protobuf field: bool is_price_rounded_up = 6
     */
    isPriceRoundedUp: boolean; // deprecated: use price_rounding_type instead
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 7
     */
    discountPercent?: Decimal;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceRoundingType price_rounding_type = 11
     */
    priceRoundingType: Rule_PriceRoundingType;
    /**
     * @generated from protobuf field: bool is_reference = 8
     */
    isReference: boolean;
    /**
     * @generated from protobuf field: string name = 9
     */
    name: string;
    /**
     * defaults to true if the tier is rule-based, updated if specific rule is rule-based
     *
     * @generated from protobuf field: bool is_rule_based = 10
     */
    isRuleBased: boolean;
    /**
     * UoM scope for UoM-aware tier pricing. Nil means the base unit.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 12
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID rule_id = 13
     */
    ruleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney price_fractional = 14
     */
    priceFractional?: FractionalMoney;
}
/**
 * TierPrices groups all tier prices for a single product. This just enables
 * use as a map value in API responses (e.g., tier_prices_by_product_id)
 *
 * @generated from protobuf message rd.price.TierPrices
 */
export interface TierPrices {
    /**
     * Tier × UoM matrix: base tiers (uom_id nil) plus, for each "unlinked"
     * UoM, one entry per company tier. UoMs absent from the entries with
     * a non-nil uom_id are "linked" — clients derive prices from the base
     * tier × conversion factor. Products without UoM-specific tier rules
     * produce only base entries.
     *
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 1
     */
    tierPrices: Tier[];
}
/**
 * @generated from protobuf message rd.price.RegionTierPrices
 */
export interface RegionTierPrices {
    /**
     * @generated from protobuf field: rd.company.PricingRegion pricing_region = 1
     */
    pricingRegion?: PricingRegion;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 2
     */
    tierPrices: Tier[];
}
/**
 * TierRule defines the pricing configuration for a specific pricing tier. This
 * model is used for both creating new tier rules and displaying existing tier
 * rules in the UI.
 *
 * @generated from protobuf message rd.price.TierRule
 */
export interface TierRule {
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 1
     */
    pricingTierIdString: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 3
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID class_id = 4
     */
    classId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fineline_id = 5
     */
    finelineId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 6
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceStrategy price_strategy = 12
     */
    priceStrategy: Rule_PriceStrategy;
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 13
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_percent = 14
     */
    marginPercent?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 15
     */
    discountPercent?: Decimal;
    /**
     * @generated from protobuf field: string reference_tier_id_string = 16
     */
    referenceTierIdString: string;
    /**
     * @generated from protobuf field: bool is_price_rounded_up = 17
     */
    isPriceRoundedUp: boolean; // deprecated: use price_rounding_type instead
    /**
     * @generated from protobuf field: string name = 18
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 19
     */
    id?: UUID; // rule_id
    /**
     * @generated from protobuf field: rd.price.Rule.PriceRoundingType price_rounding_type = 20
     */
    priceRoundingType: Rule_PriceRoundingType;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_tag_id = 21
     */
    productTagId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID pricing_region_id = 22
     */
    pricingRegionId?: UUID;
}
/**
 * Custom represents price information for custom prices and promotions. It
 * contains the calculated price, pricing strategy, and configuration details
 * used by the frontend to display and manage custom and promotion pricing.
 *
 * @generated from protobuf message rd.price.Custom
 */
export interface Custom {
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 1
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_percent = 2
     */
    marginPercent?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 3
     */
    discountPercent?: Decimal;
    /**
     * @generated from protobuf field: bool is_price_rounded_up = 4
     */
    isPriceRoundedUp: boolean; // deprecated: use price_rounding_type instead
    /**
     * @generated from protobuf field: string reference_tier_id_string = 5
     */
    referenceTierIdString: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 6
     */
    customerId?: UUID; // for job custom prices, this is the parent customer id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 7
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 8
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 9
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID class_id = 10
     */
    classId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fineline_id = 11
     */
    finelineId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 12
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: string name = 13
     */
    name: string;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceStrategy price_strategy = 14
     */
    priceStrategy: Rule_PriceStrategy;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID job_id = 16
     */
    jobId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 17
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 18
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp starts_at = 19
     */
    startsAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 20
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 21
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceRoundingType price_rounding_type = 22
     */
    priceRoundingType: Rule_PriceRoundingType;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_tag_id = 23
     */
    productTagId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_tag_id = 24
     */
    customerTagId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 25
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool is_quantity_break_disabled = 26
     */
    isQuantityBreakDisabled: boolean;
}
/**
 * QuantityBreak represents an quantity break rule for a product.
 * Quantity break applies a discount or markup once a UoM quantity threshold
 * is met. Always uses the discount price strategy.
 *
 * @generated from protobuf message rd.price.QuantityBreak
 */
export interface QuantityBreak {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 3
     */
    uomId?: UUID; // Nil means the product's base unit.
    /**
     * @generated from protobuf field: int32 quantity_uom = 4
     */
    quantityUom: number;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 5
     */
    pricingTierIdString: string; // Empty applies the rule across all pricing tiers.
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 6
     */
    discountPercent?: Decimal; // positive applies a discount, negative applies a markup.
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 8
     */
    createdBy?: User;
}
/**
 * RuleItem is a line item in the price hover state.
 *
 * @generated from protobuf message rd.price.RuleItem
 */
export interface RuleItem {
    /**
     * Deprecated: display string frozen at rule write time; assemble copy from the structured fields.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 2
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.price.RuleItem.Type type = 3
     */
    type: RuleItem_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID rule_id = 4
     */
    ruleId?: UUID;
    /**
     * @generated from protobuf field: bool is_winner = 5
     */
    isWinner: boolean;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceStrategy price_strategy = 6
     */
    priceStrategy: Rule_PriceStrategy;
    /**
     * @generated from protobuf field: rd.proto.money.Money fixed_price = 7
     */
    fixedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percent = 8
     */
    discountPercent?: Decimal;
    /**
     * @generated from protobuf field: string reference_tier_id_string = 9
     */
    referenceTierIdString: string;
    /**
     * @generated from protobuf field: string reference_tier_name = 10
     */
    referenceTierName: string;
    /**
     * @generated from protobuf field: rd.price.Rule.PriceRoundingType price_rounding_type = 11
     */
    priceRoundingType: Rule_PriceRoundingType;
    /**
     * @generated from protobuf field: string tier_id_string = 12
     */
    tierIdString: string;
    /**
     * @generated from protobuf field: string tier_name = 13
     */
    tierName: string;
    /**
     * @generated from protobuf field: int32 tier_number = 14
     */
    tierNumber: number;
    /**
     * @generated from protobuf field: string promo_name = 15
     */
    promoName: string;
    /**
     * @generated from protobuf field: bool is_quantity_break_disabled = 16
     */
    isQuantityBreakDisabled: boolean;
}
/**
 * @generated from protobuf enum rd.price.RuleItem.Type
 */
export enum RuleItem_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_TIER = 1;
     */
    TIER = 1,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOM = 2;
     */
    CUSTOM = 2,
    /**
     * @generated from protobuf enum value: TYPE_PROMOTION = 3;
     */
    PROMOTION = 3,
    /**
     * @generated from protobuf enum value: TYPE_MATCH = 4;
     */
    MATCH = 4
}
/**
 * RuleInformation contains RuleItems for the price hover state.
 *
 * @generated from protobuf message rd.price.RuleInformation
 */
export interface RuleInformation {
    /**
     * @generated from protobuf field: repeated rd.price.RuleItem rule_items = 1
     */
    ruleItems: RuleItem[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID matched_product_id = 2
     */
    matchedProductId?: UUID;
    /**
     * @generated from protobuf field: string matched_product_identifier = 3
     */
    matchedProductIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_break_discount = 4
     */
    quantityBreakDiscount?: Decimal;
}
// @generated message type with reflection information, may provide speed optimized methods
class Rule$Type extends MessageType<Rule> {
    constructor() {
        super("rd.price.Rule", [
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "product_id", kind: "message", T: () => UUID },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID },
            { no: 5, name: "matched_product_id", kind: "message", T: () => UUID },
            { no: 6, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 7, name: "department_id", kind: "message", T: () => UUID },
            { no: 8, name: "class_id", kind: "message", T: () => UUID },
            { no: 9, name: "fineline_id", kind: "message", T: () => UUID },
            { no: 10, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "reference_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "price_strategy", kind: "enum", T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 14, name: "fixed_price", kind: "message", T: () => Money },
            { no: 15, name: "margin_percent", kind: "message", T: () => Decimal },
            { no: 16, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 28, name: "starts_at", kind: "message", T: () => Timestamp },
            { no: 17, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "type", kind: "enum", T: () => ["rd.price.Rule.Type", Rule_Type, "TYPE_"] },
            { no: 20, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 21, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 22, name: "is_price_rounded_up", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "price_tier_type", kind: "enum", T: () => ["rd.price.Rule.PriceTierType", Rule_PriceTierType, "PRICE_TIER_TYPE_"] },
            { no: 25, name: "job_id", kind: "message", T: () => UUID },
            { no: 26, name: "created_by", kind: "message", T: () => User },
            { no: 27, name: "updated_by", kind: "message", T: () => User },
            { no: 29, name: "location_id", kind: "message", T: () => UUID },
            { no: 30, name: "id", kind: "message", T: () => UUID },
            { no: 31, name: "price_rounding_type", kind: "enum", T: () => ["rd.price.Rule.PriceRoundingType", Rule_PriceRoundingType] },
            { no: 32, name: "product_tag_id", kind: "message", T: () => UUID },
            { no: 33, name: "customer_tag_id", kind: "message", T: () => UUID },
            { no: 34, name: "uom_id", kind: "message", T: () => UUID },
            { no: 35, name: "quantity_uom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "pricing_region_id", kind: "message", T: () => UUID },
            { no: 37, name: "is_quantity_break_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Rule>): Rule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        message.referenceTierIdString = "";
        message.priceStrategy = 0;
        message.type = 0;
        message.isPriceRoundedUp = false;
        message.name = "";
        message.priceTierType = 0;
        message.priceRoundingType = 0;
        message.quantityUom = 0;
        message.isQuantityBreakDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<Rule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Rule): Rule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 3:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID matched_product_id */ 5:
                    message.matchedProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.matchedProductId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 6:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.uuid.UUID department_id */ 7:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.proto.uuid.UUID class_id */ 8:
                    message.classId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.classId);
                    break;
                case /* rd.proto.uuid.UUID fineline_id */ 9:
                    message.finelineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.finelineId);
                    break;
                case /* string pricing_tier_id_string */ 10:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* string reference_tier_id_string */ 11:
                    message.referenceTierIdString = reader.string();
                    break;
                case /* rd.price.Rule.PriceStrategy price_strategy */ 13:
                    message.priceStrategy = reader.int32();
                    break;
                case /* rd.proto.money.Money fixed_price */ 14:
                    message.fixedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.fixedPrice);
                    break;
                case /* rd.proto.decimal.Decimal margin_percent */ 15:
                    message.marginPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginPercent);
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 16:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* google.protobuf.Timestamp starts_at */ 28:
                    message.startsAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startsAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 17:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* rd.price.Rule.Type type */ 18:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 20:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 21:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool is_price_rounded_up */ 22:
                    message.isPriceRoundedUp = reader.bool();
                    break;
                case /* string name */ 23:
                    message.name = reader.string();
                    break;
                case /* rd.price.Rule.PriceTierType price_tier_type */ 24:
                    message.priceTierType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID job_id */ 25:
                    message.jobId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.jobId);
                    break;
                case /* rd.user.User created_by */ 26:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 27:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 29:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID id */ 30:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.price.Rule.PriceRoundingType price_rounding_type */ 31:
                    message.priceRoundingType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID product_tag_id */ 32:
                    message.productTagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productTagId);
                    break;
                case /* rd.proto.uuid.UUID customer_tag_id */ 33:
                    message.customerTagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerTagId);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 34:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* int32 quantity_uom */ 35:
                    message.quantityUom = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID pricing_region_id */ 36:
                    message.pricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegionId);
                    break;
                case /* bool is_quantity_break_disabled */ 37:
                    message.isQuantityBreakDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Rule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 3; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID matched_product_id = 5; */
        if (message.matchedProductId)
            UUID.internalBinaryWrite(message.matchedProductId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 6; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID department_id = 7; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID class_id = 8; */
        if (message.classId)
            UUID.internalBinaryWrite(message.classId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fineline_id = 9; */
        if (message.finelineId)
            UUID.internalBinaryWrite(message.finelineId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string pricing_tier_id_string = 10; */
        if (message.pricingTierIdString !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* string reference_tier_id_string = 11; */
        if (message.referenceTierIdString !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.referenceTierIdString);
        /* rd.price.Rule.PriceStrategy price_strategy = 13; */
        if (message.priceStrategy !== 0)
            writer.tag(13, WireType.Varint).int32(message.priceStrategy);
        /* rd.proto.money.Money fixed_price = 14; */
        if (message.fixedPrice)
            Money.internalBinaryWrite(message.fixedPrice, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_percent = 15; */
        if (message.marginPercent)
            Decimal.internalBinaryWrite(message.marginPercent, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_percent = 16; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 17; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.Type type = 18; */
        if (message.type !== 0)
            writer.tag(18, WireType.Varint).int32(message.type);
        /* google.protobuf.Timestamp created_at = 20; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 21; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* bool is_price_rounded_up = 22; */
        if (message.isPriceRoundedUp !== false)
            writer.tag(22, WireType.Varint).bool(message.isPriceRoundedUp);
        /* string name = 23; */
        if (message.name !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.name);
        /* rd.price.Rule.PriceTierType price_tier_type = 24; */
        if (message.priceTierType !== 0)
            writer.tag(24, WireType.Varint).int32(message.priceTierType);
        /* rd.proto.uuid.UUID job_id = 25; */
        if (message.jobId)
            UUID.internalBinaryWrite(message.jobId, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 26; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 27; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp starts_at = 28; */
        if (message.startsAt)
            Timestamp.internalBinaryWrite(message.startsAt, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 29; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 30; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.PriceRoundingType price_rounding_type = 31; */
        if (message.priceRoundingType !== 0)
            writer.tag(31, WireType.Varint).int32(message.priceRoundingType);
        /* rd.proto.uuid.UUID product_tag_id = 32; */
        if (message.productTagId)
            UUID.internalBinaryWrite(message.productTagId, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_tag_id = 33; */
        if (message.customerTagId)
            UUID.internalBinaryWrite(message.customerTagId, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 34; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* int32 quantity_uom = 35; */
        if (message.quantityUom !== 0)
            writer.tag(35, WireType.Varint).int32(message.quantityUom);
        /* rd.proto.uuid.UUID pricing_region_id = 36; */
        if (message.pricingRegionId)
            UUID.internalBinaryWrite(message.pricingRegionId, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* bool is_quantity_break_disabled = 37; */
        if (message.isQuantityBreakDisabled !== false)
            writer.tag(37, WireType.Varint).bool(message.isQuantityBreakDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.Rule
 */
export const Rule = new Rule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tier$Type extends MessageType<Tier> {
    constructor() {
        super("rd.price.Tier", [
            { no: 1, name: "price", kind: "message", T: () => Money },
            { no: 2, name: "margin_percent", kind: "message", T: () => Decimal },
            { no: 3, name: "price_strategy", kind: "enum", T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 4, name: "tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_price_rounded_up", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 11, name: "price_rounding_type", kind: "enum", T: () => ["rd.price.Rule.PriceRoundingType", Rule_PriceRoundingType] },
            { no: 8, name: "is_reference", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_rule_based", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "uom_id", kind: "message", T: () => UUID },
            { no: 13, name: "rule_id", kind: "message", T: () => UUID },
            { no: 14, name: "price_fractional", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<Tier>): Tier {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.priceStrategy = 0;
        message.tierIdString = "";
        message.isPriceRoundedUp = false;
        message.priceRoundingType = 0;
        message.isReference = false;
        message.name = "";
        message.isRuleBased = false;
        if (value !== undefined)
            reflectionMergePartial<Tier>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Tier): Tier {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money price */ 1:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.proto.decimal.Decimal margin_percent */ 2:
                    message.marginPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginPercent);
                    break;
                case /* rd.price.Rule.PriceStrategy price_strategy */ 3:
                    message.priceStrategy = reader.int32();
                    break;
                case /* string tier_id_string */ 4:
                    message.tierIdString = reader.string();
                    break;
                case /* bool is_price_rounded_up */ 6:
                    message.isPriceRoundedUp = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 7:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* rd.price.Rule.PriceRoundingType price_rounding_type */ 11:
                    message.priceRoundingType = reader.int32();
                    break;
                case /* bool is_reference */ 8:
                    message.isReference = reader.bool();
                    break;
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* bool is_rule_based */ 10:
                    message.isRuleBased = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 12:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.uuid.UUID rule_id */ 13:
                    message.ruleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ruleId);
                    break;
                case /* rd.proto.money.FractionalMoney price_fractional */ 14:
                    message.priceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.priceFractional);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Tier, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money price = 1; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_percent = 2; */
        if (message.marginPercent)
            Decimal.internalBinaryWrite(message.marginPercent, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.PriceStrategy price_strategy = 3; */
        if (message.priceStrategy !== 0)
            writer.tag(3, WireType.Varint).int32(message.priceStrategy);
        /* string tier_id_string = 4; */
        if (message.tierIdString !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tierIdString);
        /* bool is_price_rounded_up = 6; */
        if (message.isPriceRoundedUp !== false)
            writer.tag(6, WireType.Varint).bool(message.isPriceRoundedUp);
        /* rd.proto.decimal.Decimal discount_percent = 7; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_reference = 8; */
        if (message.isReference !== false)
            writer.tag(8, WireType.Varint).bool(message.isReference);
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* bool is_rule_based = 10; */
        if (message.isRuleBased !== false)
            writer.tag(10, WireType.Varint).bool(message.isRuleBased);
        /* rd.price.Rule.PriceRoundingType price_rounding_type = 11; */
        if (message.priceRoundingType !== 0)
            writer.tag(11, WireType.Varint).int32(message.priceRoundingType);
        /* rd.proto.uuid.UUID uom_id = 12; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID rule_id = 13; */
        if (message.ruleId)
            UUID.internalBinaryWrite(message.ruleId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney price_fractional = 14; */
        if (message.priceFractional)
            FractionalMoney.internalBinaryWrite(message.priceFractional, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.Tier
 */
export const Tier = new Tier$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierPrices$Type extends MessageType<TierPrices> {
    constructor() {
        super("rd.price.TierPrices", [
            { no: 1, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier }
        ]);
    }
    create(value?: PartialMessage<TierPrices>): TierPrices {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<TierPrices>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierPrices): TierPrices {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.price.Tier tier_prices */ 1:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TierPrices, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.price.Tier tier_prices = 1; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.TierPrices
 */
export const TierPrices = new TierPrices$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegionTierPrices$Type extends MessageType<RegionTierPrices> {
    constructor() {
        super("rd.price.RegionTierPrices", [
            { no: 1, name: "pricing_region", kind: "message", T: () => PricingRegion },
            { no: 2, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier }
        ]);
    }
    create(value?: PartialMessage<RegionTierPrices>): RegionTierPrices {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<RegionTierPrices>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegionTierPrices): RegionTierPrices {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.PricingRegion pricing_region */ 1:
                    message.pricingRegion = PricingRegion.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegion);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 2:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegionTierPrices, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.PricingRegion pricing_region = 1; */
        if (message.pricingRegion)
            PricingRegion.internalBinaryWrite(message.pricingRegion, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 2; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.RegionTierPrices
 */
export const RegionTierPrices = new RegionTierPrices$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierRule$Type extends MessageType<TierRule> {
    constructor() {
        super("rd.price.TierRule", [
            { no: 1, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "department_id", kind: "message", T: () => UUID },
            { no: 4, name: "class_id", kind: "message", T: () => UUID },
            { no: 5, name: "fineline_id", kind: "message", T: () => UUID },
            { no: 6, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 12, name: "price_strategy", kind: "enum", T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 13, name: "price", kind: "message", T: () => Money },
            { no: 14, name: "margin_percent", kind: "message", T: () => Decimal },
            { no: 15, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 16, name: "reference_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "is_price_rounded_up", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "id", kind: "message", T: () => UUID },
            { no: 20, name: "price_rounding_type", kind: "enum", T: () => ["rd.price.Rule.PriceRoundingType", Rule_PriceRoundingType] },
            { no: 21, name: "product_tag_id", kind: "message", T: () => UUID },
            { no: 22, name: "pricing_region_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<TierRule>): TierRule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        message.priceStrategy = 0;
        message.referenceTierIdString = "";
        message.isPriceRoundedUp = false;
        message.name = "";
        message.priceRoundingType = 0;
        if (value !== undefined)
            reflectionMergePartial<TierRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierRule): TierRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pricing_tier_id_string */ 1:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID department_id */ 3:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.proto.uuid.UUID class_id */ 4:
                    message.classId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.classId);
                    break;
                case /* rd.proto.uuid.UUID fineline_id */ 5:
                    message.finelineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.finelineId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 6:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.price.Rule.PriceStrategy price_strategy */ 12:
                    message.priceStrategy = reader.int32();
                    break;
                case /* rd.proto.money.Money price */ 13:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.proto.decimal.Decimal margin_percent */ 14:
                    message.marginPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginPercent);
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 15:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* string reference_tier_id_string */ 16:
                    message.referenceTierIdString = reader.string();
                    break;
                case /* bool is_price_rounded_up */ 17:
                    message.isPriceRoundedUp = reader.bool();
                    break;
                case /* string name */ 18:
                    message.name = reader.string();
                    break;
                case /* rd.proto.uuid.UUID id */ 19:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.price.Rule.PriceRoundingType price_rounding_type */ 20:
                    message.priceRoundingType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID product_tag_id */ 21:
                    message.productTagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productTagId);
                    break;
                case /* rd.proto.uuid.UUID pricing_region_id */ 22:
                    message.pricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegionId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TierRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pricing_tier_id_string = 1; */
        if (message.pricingTierIdString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID department_id = 3; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID class_id = 4; */
        if (message.classId)
            UUID.internalBinaryWrite(message.classId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fineline_id = 5; */
        if (message.finelineId)
            UUID.internalBinaryWrite(message.finelineId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 6; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.PriceStrategy price_strategy = 12; */
        if (message.priceStrategy !== 0)
            writer.tag(12, WireType.Varint).int32(message.priceStrategy);
        /* rd.proto.money.Money price = 13; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_percent = 14; */
        if (message.marginPercent)
            Decimal.internalBinaryWrite(message.marginPercent, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_percent = 15; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string reference_tier_id_string = 16; */
        if (message.referenceTierIdString !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.referenceTierIdString);
        /* bool is_price_rounded_up = 17; */
        if (message.isPriceRoundedUp !== false)
            writer.tag(17, WireType.Varint).bool(message.isPriceRoundedUp);
        /* string name = 18; */
        if (message.name !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.name);
        /* rd.proto.uuid.UUID id = 19; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.PriceRoundingType price_rounding_type = 20; */
        if (message.priceRoundingType !== 0)
            writer.tag(20, WireType.Varint).int32(message.priceRoundingType);
        /* rd.proto.uuid.UUID product_tag_id = 21; */
        if (message.productTagId)
            UUID.internalBinaryWrite(message.productTagId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID pricing_region_id = 22; */
        if (message.pricingRegionId)
            UUID.internalBinaryWrite(message.pricingRegionId, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.TierRule
 */
export const TierRule = new TierRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Custom$Type extends MessageType<Custom> {
    constructor() {
        super("rd.price.Custom", [
            { no: 1, name: "price", kind: "message", T: () => Money },
            { no: 2, name: "margin_percent", kind: "message", T: () => Decimal },
            { no: 3, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 4, name: "is_price_rounded_up", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "reference_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "product_id", kind: "message", T: () => UUID },
            { no: 8, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 9, name: "department_id", kind: "message", T: () => UUID },
            { no: 10, name: "class_id", kind: "message", T: () => UUID },
            { no: 11, name: "fineline_id", kind: "message", T: () => UUID },
            { no: 12, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "price_strategy", kind: "enum", T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 16, name: "job_id", kind: "message", T: () => UUID },
            { no: 17, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "created_by", kind: "message", T: () => User },
            { no: 19, name: "starts_at", kind: "message", T: () => Timestamp },
            { no: 20, name: "location_id", kind: "message", T: () => UUID },
            { no: 21, name: "id", kind: "message", T: () => UUID },
            { no: 22, name: "price_rounding_type", kind: "enum", T: () => ["rd.price.Rule.PriceRoundingType", Rule_PriceRoundingType] },
            { no: 23, name: "product_tag_id", kind: "message", T: () => UUID },
            { no: 24, name: "customer_tag_id", kind: "message", T: () => UUID },
            { no: 25, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 26, name: "is_quantity_break_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Custom>): Custom {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isPriceRoundedUp = false;
        message.referenceTierIdString = "";
        message.name = "";
        message.priceStrategy = 0;
        message.priceRoundingType = 0;
        message.isQuantityBreakDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<Custom>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Custom): Custom {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money price */ 1:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.proto.decimal.Decimal margin_percent */ 2:
                    message.marginPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginPercent);
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 3:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* bool is_price_rounded_up */ 4:
                    message.isPriceRoundedUp = reader.bool();
                    break;
                case /* string reference_tier_id_string */ 5:
                    message.referenceTierIdString = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 6:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 7:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 8:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.uuid.UUID department_id */ 9:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.proto.uuid.UUID class_id */ 10:
                    message.classId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.classId);
                    break;
                case /* rd.proto.uuid.UUID fineline_id */ 11:
                    message.finelineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.finelineId);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 12:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* string name */ 13:
                    message.name = reader.string();
                    break;
                case /* rd.price.Rule.PriceStrategy price_strategy */ 14:
                    message.priceStrategy = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID job_id */ 16:
                    message.jobId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.jobId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 17:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 18:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp starts_at */ 19:
                    message.startsAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startsAt);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 20:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID id */ 21:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.price.Rule.PriceRoundingType price_rounding_type */ 22:
                    message.priceRoundingType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID product_tag_id */ 23:
                    message.productTagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productTagId);
                    break;
                case /* rd.proto.uuid.UUID customer_tag_id */ 24:
                    message.customerTagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerTagId);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 25:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool is_quantity_break_disabled */ 26:
                    message.isQuantityBreakDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Custom, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money price = 1; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_percent = 2; */
        if (message.marginPercent)
            Decimal.internalBinaryWrite(message.marginPercent, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_percent = 3; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool is_price_rounded_up = 4; */
        if (message.isPriceRoundedUp !== false)
            writer.tag(4, WireType.Varint).bool(message.isPriceRoundedUp);
        /* string reference_tier_id_string = 5; */
        if (message.referenceTierIdString !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.referenceTierIdString);
        /* rd.proto.uuid.UUID customer_id = 6; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 7; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 8; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID department_id = 9; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID class_id = 10; */
        if (message.classId)
            UUID.internalBinaryWrite(message.classId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fineline_id = 11; */
        if (message.finelineId)
            UUID.internalBinaryWrite(message.finelineId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 12; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string name = 13; */
        if (message.name !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.name);
        /* rd.price.Rule.PriceStrategy price_strategy = 14; */
        if (message.priceStrategy !== 0)
            writer.tag(14, WireType.Varint).int32(message.priceStrategy);
        /* rd.proto.uuid.UUID job_id = 16; */
        if (message.jobId)
            UUID.internalBinaryWrite(message.jobId, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 17; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 18; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp starts_at = 19; */
        if (message.startsAt)
            Timestamp.internalBinaryWrite(message.startsAt, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 20; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 21; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.Rule.PriceRoundingType price_rounding_type = 22; */
        if (message.priceRoundingType !== 0)
            writer.tag(22, WireType.Varint).int32(message.priceRoundingType);
        /* rd.proto.uuid.UUID product_tag_id = 23; */
        if (message.productTagId)
            UUID.internalBinaryWrite(message.productTagId, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_tag_id = 24; */
        if (message.customerTagId)
            UUID.internalBinaryWrite(message.customerTagId, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 25; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* bool is_quantity_break_disabled = 26; */
        if (message.isQuantityBreakDisabled !== false)
            writer.tag(26, WireType.Varint).bool(message.isQuantityBreakDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.Custom
 */
export const Custom = new Custom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuantityBreak$Type extends MessageType<QuantityBreak> {
    constructor() {
        super("rd.price.QuantityBreak", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "uom_id", kind: "message", T: () => UUID },
            { no: 4, name: "quantity_uom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "created_by", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<QuantityBreak>): QuantityBreak {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quantityUom = 0;
        message.pricingTierIdString = "";
        if (value !== undefined)
            reflectionMergePartial<QuantityBreak>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuantityBreak): QuantityBreak {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 3:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* int32 quantity_uom */ 4:
                    message.quantityUom = reader.int32();
                    break;
                case /* string pricing_tier_id_string */ 5:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 6:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 8:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuantityBreak, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 3; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 quantity_uom = 4; */
        if (message.quantityUom !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantityUom);
        /* string pricing_tier_id_string = 5; */
        if (message.pricingTierIdString !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* rd.proto.decimal.Decimal discount_percent = 6; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 8; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.QuantityBreak
 */
export const QuantityBreak = new QuantityBreak$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RuleItem$Type extends MessageType<RuleItem> {
    constructor() {
        super("rd.price.RuleItem", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "price", kind: "message", T: () => Money },
            { no: 3, name: "type", kind: "enum", T: () => ["rd.price.RuleItem.Type", RuleItem_Type, "TYPE_"] },
            { no: 4, name: "rule_id", kind: "message", T: () => UUID },
            { no: 5, name: "is_winner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "price_strategy", kind: "enum", T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 7, name: "fixed_price", kind: "message", T: () => Money },
            { no: 8, name: "discount_percent", kind: "message", T: () => Decimal },
            { no: 9, name: "reference_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "reference_tier_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "price_rounding_type", kind: "enum", T: () => ["rd.price.Rule.PriceRoundingType", Rule_PriceRoundingType] },
            { no: 12, name: "tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "tier_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tier_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "promo_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "is_quantity_break_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RuleItem>): RuleItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.isWinner = false;
        message.priceStrategy = 0;
        message.referenceTierIdString = "";
        message.referenceTierName = "";
        message.priceRoundingType = 0;
        message.tierIdString = "";
        message.tierName = "";
        message.tierNumber = 0;
        message.promoName = "";
        message.isQuantityBreakDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<RuleItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RuleItem): RuleItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money price */ 2:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.price.RuleItem.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID rule_id */ 4:
                    message.ruleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ruleId);
                    break;
                case /* bool is_winner */ 5:
                    message.isWinner = reader.bool();
                    break;
                case /* rd.price.Rule.PriceStrategy price_strategy */ 6:
                    message.priceStrategy = reader.int32();
                    break;
                case /* rd.proto.money.Money fixed_price */ 7:
                    message.fixedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.fixedPrice);
                    break;
                case /* rd.proto.decimal.Decimal discount_percent */ 8:
                    message.discountPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercent);
                    break;
                case /* string reference_tier_id_string */ 9:
                    message.referenceTierIdString = reader.string();
                    break;
                case /* string reference_tier_name */ 10:
                    message.referenceTierName = reader.string();
                    break;
                case /* rd.price.Rule.PriceRoundingType price_rounding_type */ 11:
                    message.priceRoundingType = reader.int32();
                    break;
                case /* string tier_id_string */ 12:
                    message.tierIdString = reader.string();
                    break;
                case /* string tier_name */ 13:
                    message.tierName = reader.string();
                    break;
                case /* int32 tier_number */ 14:
                    message.tierNumber = reader.int32();
                    break;
                case /* string promo_name */ 15:
                    message.promoName = reader.string();
                    break;
                case /* bool is_quantity_break_disabled */ 16:
                    message.isQuantityBreakDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RuleItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money price = 2; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.RuleItem.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID rule_id = 4; */
        if (message.ruleId)
            UUID.internalBinaryWrite(message.ruleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_winner = 5; */
        if (message.isWinner !== false)
            writer.tag(5, WireType.Varint).bool(message.isWinner);
        /* rd.price.Rule.PriceStrategy price_strategy = 6; */
        if (message.priceStrategy !== 0)
            writer.tag(6, WireType.Varint).int32(message.priceStrategy);
        /* rd.proto.money.Money fixed_price = 7; */
        if (message.fixedPrice)
            Money.internalBinaryWrite(message.fixedPrice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_percent = 8; */
        if (message.discountPercent)
            Decimal.internalBinaryWrite(message.discountPercent, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string reference_tier_id_string = 9; */
        if (message.referenceTierIdString !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.referenceTierIdString);
        /* string reference_tier_name = 10; */
        if (message.referenceTierName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.referenceTierName);
        /* rd.price.Rule.PriceRoundingType price_rounding_type = 11; */
        if (message.priceRoundingType !== 0)
            writer.tag(11, WireType.Varint).int32(message.priceRoundingType);
        /* string tier_id_string = 12; */
        if (message.tierIdString !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.tierIdString);
        /* string tier_name = 13; */
        if (message.tierName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.tierName);
        /* int32 tier_number = 14; */
        if (message.tierNumber !== 0)
            writer.tag(14, WireType.Varint).int32(message.tierNumber);
        /* string promo_name = 15; */
        if (message.promoName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.promoName);
        /* bool is_quantity_break_disabled = 16; */
        if (message.isQuantityBreakDisabled !== false)
            writer.tag(16, WireType.Varint).bool(message.isQuantityBreakDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.RuleItem
 */
export const RuleItem = new RuleItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RuleInformation$Type extends MessageType<RuleInformation> {
    constructor() {
        super("rd.price.RuleInformation", [
            { no: 1, name: "rule_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RuleItem },
            { no: 2, name: "matched_product_id", kind: "message", T: () => UUID },
            { no: 3, name: "matched_product_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity_break_discount", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<RuleInformation>): RuleInformation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ruleItems = [];
        message.matchedProductIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<RuleInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RuleInformation): RuleInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.price.RuleItem rule_items */ 1:
                    message.ruleItems.push(RuleItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID matched_product_id */ 2:
                    message.matchedProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.matchedProductId);
                    break;
                case /* string matched_product_identifier */ 3:
                    message.matchedProductIdentifier = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_break_discount */ 4:
                    message.quantityBreakDiscount = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityBreakDiscount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RuleInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.price.RuleItem rule_items = 1; */
        for (let i = 0; i < message.ruleItems.length; i++)
            RuleItem.internalBinaryWrite(message.ruleItems[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID matched_product_id = 2; */
        if (message.matchedProductId)
            UUID.internalBinaryWrite(message.matchedProductId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string matched_product_identifier = 3; */
        if (message.matchedProductIdentifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.matchedProductIdentifier);
        /* rd.proto.decimal.Decimal quantity_break_discount = 4; */
        if (message.quantityBreakDiscount)
            Decimal.internalBinaryWrite(message.quantityBreakDiscount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.price.RuleInformation
 */
export const RuleInformation = new RuleInformation$Type();
